import React, { useEffect } from "react";
import {
  Box,
  Flex,
  Heading,
  FormLabel,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Select from "react-select";
import {
  closeAddSectionkModel,
} from "../../../../modules/admin-modules/models/Actions";
import MainModel from "../../../../components/Models/main-model";
import { useForm } from "react-hook-form";
import MainInput from "../../../../components/Form/input";
import { getAllGroupsRequest } from "../../../../modules/admin-modules/groups/Actions";

import {
  createAdminSectionRequest,
  editAdminSectionRequest,
} from "../../../../modules/admin-modules/sections/Actions";

const AddSection = ({ isAdd, data, setSelectedData }) => {
  const openChapter = useSelector((state) => state.model.isOpen29);
  const isLoading = useSelector((state) => state.adminSections.isLoading);
  const groups = useSelector((state) => state.groups.groups);
  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });
  console.log(groupsOptions, "groupsOptions");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllGroupsRequest());
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: !isAdd ? data : {},
    shouldUnregister: true,
  });

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة الفصل" : "تعديل  الفصل"}
      </Heading>
    </Box>
  );

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const onSubmit = async (values) => {
    const action = () => {
      dispatch(closeAddSectionkModel());
      setSelectedData({});
      reset();
    };
    if (isAdd) {
      let formData = await new FormData();
      formData.append("name", values?.name);
      for (let key in values) {
        if (key == "student_group_ids") {
          values[key]?.map((val, idx) =>
            formData.append(`student_group_ids[${idx}]`, val)
          );
        } else if (values[key]) {
          formData.append(key, values[key]);
        }
      }

      await dispatch(createAdminSectionRequest(formData, action));
    } else {
      let formData = await new FormData();
      formData.append("_method", "PUT");
      const totel = { ...data, ...values };
      formData.append("name", totel?.name);

      if (values?.student_group_ids) {
        values?.student_group_ids?.map((val, idx) =>
          formData.append(`student_group_ids[${idx}]`, val)
        );
      }

      dispatch(
        editAdminSectionRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };
  const closeFunc = () => {
    dispatch(closeAddSectionkModel());
    setSelectedData({});
    reset();
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openChapter}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          dir="rtl"
          w="100%"
          flexWrap="wrap"
          justifyContent="space-between"
          gap="4"
        >
          <Box w="45%">
            <MainInput
              label="اسم القسم "
              defaultValues={data?.name}
              error={errors?.name?.message}
              placeholder="ادخل اسم القسم "
              register={register}
              name="name"
            />
          </Box>
          <Box w="45%">
            <FormLabel>المجموعات</FormLabel>
            <Select
              options={groupsOptions}
              isMulti={true}
              defaultValue={data?.groups?.map((val) => {
                return { label: val?.name, value: val?.id };
              })}
              onChange={(data) => {
                const selectedGroups = data.map((val) => val.value);
                setValue("student_group_ids", selectedGroups);
              }}
              styles={colourStyles}
              placeholder="المجموعات"
            />
          </Box>
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddSection;
